<div class="sidebar-container">
  <div class="sidebar-inner">
    @if (showUnseenActivityFilter) {
      <div
        class="unseen-activity-filter"
        [class.toggled]="allFilters.unseen_activity.with"
        (click)="allFilters.unseen_activity.with = !allFilters.unseen_activity.with; handleFilter('unseen_activity')"
      >
        <app-svg src="/assets/icons/bolt.svg"></app-svg>
        <span>New Activities ({{ assetCounts.get('unseen_activity_with') }})</span>

        <div class="switch small" appTransitionPreventor>
          <input
            type="checkbox"
            name="toggle-new-activity-filter"
            id="toggle-new-activity-filter"
            [checked]="allFilters.unseen_activity.with"
          />
          <label for="toggle-new-activity-filter"></label>
        </div>
      </div>

      <div class="unseen-activity-divider"></div>
    }

    <app-toggler special="am" [open]="!!people?.length" #peopleToggler>
      <span togglerHeader
        >People
        @if (areChanges('people')) {
          <span class="changes-dot"></span>
        }
      </span>
      <div togglerBody>
        @if (!people?.length) {
          <div class="not-enabled">
            <span>No-one has left any feeback so far</span>
          </div>
        }
        @for (person of people; track person.userOrGuest.id) {
          <div class="radio-box">
            <input
              type="checkbox"
              id="person-{{ person.userOrGuest['id'] }}"
              [(ngModel)]="allFilters.people[person.userOrGuest['id']]"
              (ngModelChange)="handleFilter('people')"
            />
            <label for="person-{{ person.userOrGuest['id'] }}">
              <app-context-menu
                [options]="{ width: '240px', openOnHover: true, allowClicks: true, noSpacing: true }"
                [disabled]="!isDesktop || !isTeamMember"
                #menu
              >
                <div class="profile-circle" contextButton [class.auto-border]="person.userOrGuest?.['avatar_url']">
                  <app-avatar class="person-avatar" [user]="person.userOrGuest"></app-avatar>
                </div>
                <div contextContent>
                  @if (menu.isOpen) {
                    <app-profile-preview
                      [user]="person.type === 'user' ? $any(person.userOrGuest) : undefined"
                      [guest]="person.type === 'guest' ? $any(person.userOrGuest) : undefined"
                      [email]="emailMap[person.userOrGuest['id']]"
                    ></app-profile-preview>
                  }
                </div>
              </app-context-menu>
              <div class="person-info">
                <span class="asset-counter-flex">
                  <span class="person-name">
                    @if (person.userOrGuest['name']) {
                      {{ person.userOrGuest['name'] }}
                    }
                    @if (!person.userOrGuest['name']) {
                      @if (person.userOrGuest['last_name']) {
                        {{ person.userOrGuest['first_name'] + ' ' + person.userOrGuest['last_name'] }}
                      }
                      @if (!person.userOrGuest['last_name']) {
                        {{ person.userOrGuest['first_name'] }}
                      }
                    }
                  </span>
                  <span class="asset-count" [class.none]="!assetCounts.get('people_' + person.userOrGuest['id'])">
                    (<app-smooth-counter [value]="assetCounts.get('people_' + person.userOrGuest['id'])">
                    </app-smooth-counter
                    >)
                  </span>
                </span>
              </div>
            </label>
          </div>
        }
      </div>
    </app-toggler>
    @if (allowedFeedbackOptions.includes('favourite')) {
      <app-toggler
        special="am"
        [open]="allowedAndEnabledFeedbackOptions.includes('favourite')"
        #favouriteToggler
        (onOpen)="calcAssetCountsDebounced()"
      >
        <span togglerHeader
          >{{ 'favorites' | translate }}
          @if (areChanges('likes')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (!allowedAndEnabledFeedbackOptions.includes('favourite')) {
            <div class="not-enabled" (click)="openSettingsDialog()">
              <span>This review option is turned off and only you can see this. <b>Review Settings</b></span>
            </div>
          }
          <div class="radio-box">
            <input
              type="checkbox"
              id="all-favorited"
              [(ngModel)]="allFilters.likes.with"
              (ngModelChange)="handleFilter('all-favorited')"
            />
            <label for="all-favorited">
              <app-svg src="/assets/icons/heart-empty.svg" [attr.color]="allFilters.likes.with ? 'warn' : ''">
              </app-svg>
              <span class="asset-counter-flex"
                >{{ 'favorited' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('likes_with')">
                  (<app-smooth-counter [value]="assetCounts.get('likes_with')"> </app-smooth-counter>)
                </span></span
              >
            </label>
          </div>
          <div class="radio-box" [class.disabled]="personFilterActive" data-test-id="not-favorited-checkbox">
            <input
              type="checkbox"
              id="not-favorited"
              [disabled]="personFilterActive"
              [(ngModel)]="allFilters.likes.without"
              (ngModelChange)="handleFilter('not-favorited')"
            />
            <label for="not-favorited">
              <app-svg src="/assets/icons/heart-dotted.svg" [attr.color]="allFilters.likes.without ? 'warn' : ''">
              </app-svg>
              <span class="asset-counter-flex"
                >{{ 'not-favorited' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('likes_without')"
                  >(<app-smooth-counter [value]="assetCounts.get('likes_without')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
        </div>
      </app-toggler>
    }
    @if (allowedFeedbackOptions.includes('status')) {
      <app-toggler
        special="am"
        [open]="allowedAndEnabledFeedbackOptions.includes('status')"
        #statusToggler
        (onOpen)="calcAssetCountsDebounced()"
      >
        <span togglerHeader>
          {{ 'status' | translate }}
          @if (areChanges('status')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (!allowedAndEnabledFeedbackOptions.includes('status')) {
            <div class="not-enabled" (click)="openSettingsDialog()">
              <span>This review option is turned off and only you can see this. <b>Review Settings</b></span>
            </div>
          }
          @for (status of gallery.enabled_asset_statuses | assetStatusOrder: true; track status) {
            <div class="radio-box" [class.disabled]="personFilterActive && status === 'no_status'">
              <input
                type="checkbox"
                [id]="'status-' + status"
                [disabled]="personFilterActive && status === 'no_status'"
                [(ngModel)]="allFilters.status[status]"
                (ngModelChange)="handleFilter(status)"
              />
              <label [for]="'status-' + status">
                <app-svg [src]="'/assets/icons/' + (status | assetStatusIcon) + '.svg'"></app-svg>
                <span class="asset-counter-flex"
                  >{{ status | assetStatusName }}
                  <span class="asset-count" [class.none]="!assetCounts.get('status_' + status)"
                    >(<app-smooth-counter [value]="assetCounts.get('status_' + status)"> </app-smooth-counter>)</span
                  ></span
                >
              </label>
            </div>
          }
        </div>
      </app-toggler>
    }
    @if (allowedFeedbackOptions.includes('comment')) {
      <app-toggler
        special="am"
        [open]="allowedAndEnabledFeedbackOptions.includes('comment')"
        #commentToggler
        (onOpen)="calcAssetCountsDebounced()"
      >
        <span togglerHeader
          >{{ 'comments' | translate }}
          @if (areChanges('comments')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (!allowedAndEnabledFeedbackOptions.includes('comment')) {
            <div class="not-enabled" (click)="openSettingsDialog()">
              <span>This review option is turned off and only you can see this. <b>Review Settings</b></span>
            </div>
          }
          <div class="radio-box">
            <input
              type="checkbox"
              id="with-comments"
              [(ngModel)]="allFilters.comments.with"
              (ngModelChange)="handleFilter('with-comments')"
            />
            <label for="with-comments">
              <app-svg src="/assets/icons/comment-bubble.svg"></app-svg>
              <span class="asset-counter-flex"
                >{{ 'commented' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('comments_with')"
                  >(<app-smooth-counter [value]="assetCounts.get('comments_with')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
          <div class="radio-box" [class.disabled]="personFilterActive">
            <input
              type="checkbox"
              id="without-comments"
              [disabled]="personFilterActive"
              [(ngModel)]="allFilters.comments.without"
              (ngModelChange)="handleFilter('without-comments')"
            />
            <label for="without-comments">
              <app-svg src="/assets/icons/comment-dotted.svg"></app-svg>
              <span class="asset-counter-flex"
                >{{ 'not-commented' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('comments_without')"
                  >(<app-smooth-counter [value]="assetCounts.get('comments_without')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
        </div>
      </app-toggler>
    }
    @if (allowedFeedbackOptions.includes('annotation')) {
      <app-toggler
        special="am"
        [open]="allowedAndEnabledFeedbackOptions.includes('annotation')"
        #annotationToggler
        (onOpen)="calcAssetCountsDebounced()"
      >
        <span togglerHeader
          >{{ 'annotations' | translate }}
          @if (areChanges('annotations')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (!allowedAndEnabledFeedbackOptions.includes('annotation')) {
            <div class="not-enabled" (click)="openSettingsDialog()">
              <span>This review option is turned off and only you can see this. <b>Review Settings</b></span>
            </div>
          }
          <div class="radio-box">
            <input
              type="checkbox"
              id="with-annotations"
              [(ngModel)]="allFilters.annotations.with"
              (ngModelChange)="handleFilter('with-annotations')"
            />
            <label for="with-annotations">
              <app-svg src="/assets/icons/annotation.svg"></app-svg>
              <span class="asset-counter-flex"
                >{{ 'annotated' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('annotations_with')"
                  >(<app-smooth-counter [value]="assetCounts.get('annotations_with')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
          <div class="radio-box" [class.disabled]="personFilterActive">
            <input
              type="checkbox"
              id="without-annotations"
              [disabled]="personFilterActive"
              [(ngModel)]="allFilters.annotations.without"
              (ngModelChange)="handleFilter('without-annotations')"
            />
            <label for="without-annotations">
              <app-svg src="/assets/icons/annotation-dotted.svg"></app-svg>
              <span class="asset-counter-flex"
                >{{ 'not-annotated' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('annotations_without')"
                  >(<app-smooth-counter [value]="assetCounts.get('annotations_without')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
        </div>
      </app-toggler>
    }
    @if (allowedFeedbackOptions.includes('color_label')) {
      <app-toggler
        special="am"
        [open]="allowedAndEnabledFeedbackOptions.includes('color_label')"
        #colorLabelToggler
        (onOpen)="calcAssetCountsDebounced()"
      >
        <span togglerHeader
          >{{ 'labels' | translate }}
          @if (areChanges('color_label')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (!allowedAndEnabledFeedbackOptions.includes('color_label')) {
            <div class="not-enabled" (click)="openSettingsDialog()">
              <span>This review option is turned off and only you can see this. <b>Review Settings</b></span>
            </div>
          }
          @for (label of colorLabels; track label) {
            @if (label.active) {
              <div class="radio-box">
                <input
                  type="checkbox"
                  id="label-{{ label.color }}"
                  [(ngModel)]="allFilters.color_label[label.color]"
                  (ngModelChange)="handleFilter('label-' + label.color)"
                />
                <label for="label-{{ label.color }}">
                  <app-svg src="/assets/icons/color-label-filled.svg" [attr.color]="label.color"></app-svg>
                  <span class="asset-counter-flex"
                    >{{ label.name | translateLabel }}
                    <span class="asset-count" [class.none]="!assetCounts.get('color_label_' + label.color)"
                      >(<app-smooth-counter [value]="assetCounts.get('color_label_' + label.color)">
                      </app-smooth-counter
                      >)</span
                    ></span
                  >
                </label>
              </div>
            }
          }
          <div class="radio-box" [class.disabled]="personFilterActive">
            <input
              type="checkbox"
              id="label-{{ null }}"
              [(ngModel)]="allFilters.color_label['null']"
              [disabled]="personFilterActive"
              (ngModelChange)="handleFilter('label-none')"
            />
            <label for="label-{{ null }}">
              <app-svg src="/assets/icons/color-label-dotted.svg" [attr.color]="'gray'"></app-svg>
              <span class="asset-counter-flex"
                >{{ 'not-labeled' | translate }}
                <span class="asset-count" [class.none]="!assetCounts.get('color_label_null')"
                  >(<app-smooth-counter [value]="assetCounts.get('color_label_null')"> </app-smooth-counter>)</span
                ></span
              >
            </label>
          </div>
        </div>
      </app-toggler>
    }
    @if (accessLevel === 'edit' && (growthBook.isOn('asset-tags') || (tenantTags$ | async)?.length)) {
      <app-toggler special="am" [open]="false" #tagsToggler (onOpen)="calcAssetCountsDebounced()">
        <span togglerHeader
          >{{ 'tags' | translate }}
          @if (areChanges('tags')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @if (galleryTags$ | async; as galleryTags) {
            @if (galleryTags.length === 0) {
              <div class="not-enabled">
                <span>No tags have been added to this gallery yet</span>
              </div>
            }
            @for (tag of galleryTags; track tag.id) {
              <div class="radio-box">
                <input
                  type="checkbox"
                  id="tag-{{ tag.id }}"
                  [(ngModel)]="allFilters.tags[tag.id]"
                  (ngModelChange)="handleFilter('tag-' + tag.id)"
                />
                <label for="tag-{{ tag.id }}">
                  <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
                  <span class="asset-counter-flex"
                    >{{ tag.name }}
                    <span class="asset-count" [class.none]="!assetCounts.get('tags_' + tag.id)"
                      >(<app-smooth-counter [value]="assetCounts.get('tags_' + tag.id)"></app-smooth-counter>)</span
                    ></span
                  >
                </label>
              </div>
            }
          }
        </div>
      </app-toggler>
    }
    @if (accessLevel === 'edit' || gallery?.save_camera_metadata) {
      <app-toggler special="am" [open]="false" #exif1Toggler (onOpen)="calcAssetCountsDebounced()">
        <span togglerHeader
          >{{ 'camera-and-lens' | translate }}
          @if (areChanges('camera') || areChanges('lens') || areChanges('focalLength')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @for (value of dynamicFilterValues.camera; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="camera-{{ value }}"
                [(ngModel)]="allFilters.camera[value]"
                (ngModelChange)="handleFilter('camera-' + value)"
              />
              <label for="camera-{{ value }}">
                <app-svg src="/assets/icons/camera.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-camera-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('camera_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('camera_' + value)"> </app-smooth-counter>)</span
                  ></span
                >
              </label>
            </div>
          }
          @for (value of dynamicFilterValues.lens; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="lens-{{ value }}"
                [(ngModel)]="allFilters.lens[value]"
                (ngModelChange)="handleFilter('lens-' + value)"
              />
              <label for="lens-{{ value }}">
                <app-svg src="/assets/icons/lens.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-lens-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('lens_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('lens_' + value)"> </app-smooth-counter>)</span
                  ></span
                >
              </label>
            </div>
          }
          @for (value of dynamicFilterValues.focalLength; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="focalLength-{{ value }}"
                [(ngModel)]="allFilters.focalLength[value]"
                (ngModelChange)="handleFilter('focal-length-' + value)"
              />
              <label for="focalLength-{{ value }}">
                <app-svg src="/assets/icons/focal-eye.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-focal-length-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('focalLength_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('focalLength_' + value)"> </app-smooth-counter
                    >)</span
                  ></span
                >
              </label>
            </div>
          }
        </div>
      </app-toggler>
    }
    @if (accessLevel === 'edit' || gallery?.save_camera_metadata) {
      <app-toggler special="am" [open]="false" #exif2Toggler (onOpen)="calcAssetCountsDebounced()">
        <span togglerHeader
          >{{ 'exposure' | translate }}
          @if (areChanges('aperture') || areChanges('shutterSpeed') || areChanges('iso')) {
            <span class="changes-dot"></span>
          }
        </span>
        <div togglerBody>
          @for (value of dynamicFilterValues.aperture; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="aperture-{{ value }}"
                [(ngModel)]="allFilters.aperture[value]"
                (ngModelChange)="handleFilter('aperture-' + value)"
              />
              <label for="aperture-{{ value }}">
                <app-svg src="/assets/icons/shutter.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-aperture-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('aperture_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('aperture_' + value)"> </app-smooth-counter>)</span
                  ></span
                >
              </label>
            </div>
          }
          @for (value of dynamicFilterValues.shutterSpeed; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="shutterSpeed-{{ value }}"
                [(ngModel)]="allFilters.shutterSpeed[value]"
                (ngModelChange)="handleFilter('shutter-speed-' + value)"
              />
              <label for="shutterSpeed-{{ value }}">
                <app-svg src="/assets/icons/clock-timer.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-shutter-speed-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('shutterSpeed_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('shutterSpeed_' + value)"> </app-smooth-counter
                    >)</span
                  ></span
                >
              </label>
            </div>
          }
          @for (value of dynamicFilterValues.iso; track value) {
            <div class="radio-box">
              <input
                type="checkbox"
                id="iso-{{ value }}"
                [(ngModel)]="allFilters.iso[value]"
                (ngModelChange)="handleFilter('iso-' + value)"
              />
              <label for="iso-{{ value }}">
                <app-svg src="/assets/icons/iso.svg"></app-svg>
                <span class="asset-counter-flex"
                  >{{ value || ('no-iso-info' | translate) }}
                  <span class="asset-count" [class.none]="!assetCounts.get('iso_' + value)"
                    >(<app-smooth-counter [value]="assetCounts.get('iso_' + value)"> </app-smooth-counter>)</span
                  ></span
                >
              </label>
            </div>
          }
        </div>
      </app-toggler>
    }
  </div>
  <div class="ctas" [class.one-button]="!filters.length">
    <button
      appButton
      name="select-all"
      location="advanced-mode-sidebar"
      (click)="selectAll()"
      color="primary"
      spacing="full"
      [class.disabled]="!assets.length"
      class="select-all-button"
    >
      <span>Select</span>
      <app-smooth-counter [value]="assets.length"></app-smooth-counter>
      <span>
        @if (assets.length !== 1) {
          assets
        } @else {
          asset
        }
      </span>
    </button>
    @if (filters.length) {
      <button
        appButton
        name="reset-filters"
        data-test-id="reset-filters"
        location="advanced-mode-sidebar"
        [hasIcon]="true"
        (click)="resetFilters()"
        color="hard-simple"
        spacing="full"
      >
        <app-svg src="/assets/icons/undo.svg"></app-svg>
        <span>{{ 'reset-filters' | translate }}</span>
      </button>
    }
  </div>
</div>
